export enum RoleSlug {
  NEW_USER = 'NEW_USER',
  SYSTEM_ADMIN = 'SYSTEM_ADMIN',
  SUPER_ADMIN = 'SUPER_ADMIN',
  SYSTEM_MANAGER = 'SYSTEM_MANAGER',
  SAFETY_MANAGER = 'SAFETY_MANAGER',
  BUSINESS_MANAGER = 'BUSINESS_MANAGER',
  STORM_ADMIN = 'STORM_ADMIN',
  GENERAL_FOREMAN = 'GENERAL_FOREMAN',
  LINEMAN = 'LINEMAN',
  NON_LINEMAN = 'NON_LINEMAN',
  FLEET_MANAGER = 'FLEET_MANAGER',
  YARD_HAND = 'YARD_HAND',
  MECHANIC = 'MECHANIC',
}

export enum TenantRoleSlug {
  SAFETY_MANAGER = 'SAFETY_MANAGER',
  BUSINESS_MANAGER = 'BUSINESS_MANAGER',
  STORM_ADMIN = 'STORM_ADMIN',
  GENERAL_FOREMAN = 'GENERAL_FOREMAN',
  FLEET_MANAGER = 'FLEET_MANAGER',
  YARD_HAND = 'YARD_HAND',
  MECHANIC = 'MECHANIC',
}

export enum TenantRoleWithSuperSlug {
  SUPER_ADMIN = 'SUPER_ADMIN',
  SAFETY_MANAGER = 'SAFETY_MANAGER',
  BUSINESS_MANAGER = 'BUSINESS_MANAGER',
  STORM_ADMIN = 'STORM_ADMIN',
  GENERAL_FOREMAN = 'GENERAL_FOREMAN',
  FLEET_MANAGER = 'FLEET_MANAGER',
  YARD_HAND = 'YARD_HAND',
  MECHANIC = 'MECHANIC',
}

export enum SharedRoleSlug {
  LINEMAN = 'LINEMAN',
  NON_LINEMAN = 'NON_LINEMAN',
}
